import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

@Component( {
    selector: 'his-search-result-select-buttons',
    templateUrl: './his-search-result-select-buttons.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisSearchResultSelectButtonsComponent {
	
    @Output() selectAllItems: EventEmitter<void> = new EventEmitter();
    @Output() clearSelectedItems: EventEmitter<void> = new EventEmitter();

    /**
     * Emits event to select all items
     */
    notifySelectAllItems(): void {
        this.selectAllItems.emit();
    }

    /**
     * Emits event to clear all selected items
     */
    notifyClearSelectedItems(): void {
        this.clearSelectedItems.emit();
    }
}